import React, { useContext } from 'react';
import './style.css';
import { ArrowLeftRight, PiggyBank, TrendingUpDown, Receipt, Plus, ArrowDownUp } from 'lucide-react';
import { WindowSizeContext } from '/src/App';

const LabAnalysisOverviewPayoff = ({
    simulatorData
}) => {

    const { deviceType } = useContext(WindowSizeContext);

    return (
        <div className={`lab-analysis-financial-details-item-payoff ${deviceType}`}>
            <div className={`lab-analysis-financial-details-item-payback ${deviceType}`}>
                <span>Est. Payoff </span>
                <div className={`lab-analysis-financial-details-item-payback-data-container ${deviceType}`}>
                    <div className={`lab-analysis-financial-details-item-payback-data-icon-container ${deviceType}`}>
                        <PiggyBank />
                    </div>
                    <span>{simulatorData.totals.totalPayoff.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                </div>
            </div>
            <div className={`lab-analysis-financial-details-vertical-divider ${deviceType}`} />
            <div className={`lab-analysis-financial-details-item-payback ${deviceType}`}>
                <span>Est. Years to Payback </span>
                <div className={`lab-analysis-financial-details-item-payback-data-container ${deviceType}`}>
                    <div className={`lab-analysis-financial-details-item-payback-data-icon-container ${deviceType}`}>
                        <TrendingUpDown />
                    </div>
                    <span>{simulatorData.payback.breakEvenYear}</span>
                </div>
            </div>
        </div>
    )
}

export default LabAnalysisOverviewPayoff;